// Insights SDK init wrapper (vendored build, see casino-admin/insights-sdk).
// Player-facing consent copy for GoldenClover (a real-money casino). Final
// wording is subject to brand/legal review.
import "./insights.min.js";
import config from "../configs/config";
import auth from "../services/auth";

export function initInsights() {
  if (!window.Insights) return;
  window.Insights.init({
    apiBase: config.apiUrl,
    brand: "play365",
    getAuthToken: () => auth.getAccessToken(),
    policyUrl: "/privacy-policy",
    copy: {
      title: "Your privacy choices",
      body:
        "We use functional cookies to keep Golden Clover running: signing in, your session and your preferences. " +
        "With your permission we also collect anonymous usage statistics to keep improving our casino. " +
        "You can change this choice at any time via Cookie Preferences in the footer.",
      accept: "Accept analytics",
      reject: "Reject",
      policyLinkLabel: "Privacy Policy",
    },
  });
}

export function openCookiePreferences() {
  if (window.Insights) window.Insights.consent.open();
}
